import { Collection, Model } from 'web-mojo';
import { LocationList } from './Location.js';
import { DeviceList } from './Device.js';

class Machine extends Model {
    constructor(data = {}) {
        super(data, {
            endpoint: '/api/camaccess/machine'
        });
    }

    nameOrId() {
        return this.get('name') || this.get('id');
    }

    isActive() {
        return this.get('is_active') !== false;
    }

    hasDevice() {
        return !!this.get('device');
    }

    locationName() {
        const loc = this.get('location');
        return loc ? loc.name : '';
    }

    deviceName() {
        const dev = this.get('device');
        return dev ? dev.name : 'No lock';
    }
}

class MachineList extends Collection {
    constructor(options = {}) {
        super({
            ModelClass: Machine,
            endpoint: '/api/camaccess/machine',
            ...options
        });
    }
}

const MachineForms = {
    edit: {
        title: 'Edit Terminal',
        fields: [
            { name: 'name', type: 'text', label: 'Terminal Name / Number', columns: 12 },
            {
                type: 'collection', name: 'location', label: 'Location', columns: 6,
                Collection: LocationList, labelField: 'name', valueField: 'id',
                maxItems: 10, placeholder: 'Search locations...', emptyFetch: false, debounceMs: 300,
            },
            {
                type: 'collection', name: 'device', label: 'Lock Device', columns: 6,
                Collection: DeviceList, labelField: 'name', valueField: 'id',
                maxItems: 10, placeholder: 'Search devices...', emptyFetch: false, debounceMs: 300,
            },
            { name: 'machine_type', type: 'text', label: 'Machine Type', columns: 6 },
            { name: 'model_number', type: 'text', label: 'Model Number', columns: 6 },
            { name: 'serial_number', type: 'text', label: 'Serial Number', columns: 6 },
            { name: 'qr_code_id', type: 'text', label: 'QR Code ID', columns: 6 },
            { name: 'nfc_tag_id', type: 'text', label: 'NFC Tag ID', columns: 6 },
        ]
    },
    create: {
        title: 'Add Terminal',
        fields: [
            { name: 'name', type: 'text', label: 'Terminal Name / Number', columns: 12 },
            {
                type: 'collection', name: 'location', label: 'Location', columns: 6,
                Collection: LocationList, labelField: 'name', valueField: 'id',
                maxItems: 10, placeholder: 'Search locations...', emptyFetch: false, debounceMs: 300,
            },
            {
                type: 'collection', name: 'device', label: 'Lock Device', columns: 6,
                Collection: DeviceList, labelField: 'name', valueField: 'id',
                maxItems: 10, placeholder: 'Search devices...', emptyFetch: false, debounceMs: 300,
            },
            { name: 'machine_type', type: 'text', label: 'Machine Type', columns: 6 },
            { name: 'model_number', type: 'text', label: 'Model Number', columns: 6 },
            { name: 'serial_number', type: 'text', label: 'Serial Number', columns: 6 },
            { name: 'qr_code_id', type: 'text', label: 'QR Code ID', columns: 6 },
            { name: 'nfc_tag_id', type: 'text', label: 'NFC Tag ID', columns: 6 },
        ]
    }
};

Machine.EDIT_FORM = MachineForms.edit;

export { Machine, MachineList, MachineForms };
